import { render, staticRenderFns } from "./retailer-offers.vue?vue&type=template&id=f5143c8c"
import script from "./retailer-offers.vue?vue&type=script&lang=js"
export * from "./retailer-offers.vue?vue&type=script&lang=js"
import style0 from "./retailer-offers.vue?vue&type=style&index=0&id=f5143c8c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports